<template>
  <div id="CatProduct" v-if="CatList && CatList.length>1">
    <!-- <SfTabs class=""> -->
    <div class="CatProduct__tabs" style="max-width: 100%;">
      <div class="CatProduct__tabs__content">
        <div v-for="(Cat, i) in CatList">
          <Sf-button class="sf-button--pure sf-tabs__title " :class="{ 'is-active': (i + 1 == activeCat) }"
            @click="changeCat(i + 1)">{{ Cat.name }}</Sf-button>
        </div>
      </div>
    </div>
    <!-- </SfTabs> -->
    <div>
      <SfLoader :loading="loading">
        <div class="CatItemList1">
          <template v-for="(product, i) in products">
            <Sf-productCard :key="i" v-if="product && product.goodId" :title="product.title" :image="product.imageUrl"
              :regular-price="product.priceMin === product.priceMax
                ? $n(product.priceMax, 'currency')
                : $n(product.priceMin, 'currency') +
                '-' +
                $n(product.priceMax, 'currency')"
              :special-price="(productGetters.getDiscountPrice(product).special) ? $n(productGetters.getDiscountPrice(product).special, 'currency') : ''"
              :show-add-to-cart-button="true" :is-on-wishlist="product.isInWishlist" :link="localePath(
                `/p/${productGetters.getId(product)}/${productGetters.getSlug(
                  product
                )}`
              )" :isInWishlist="isInWishlist({ product })" class="carousel__item__product" :scoreRating="product.rate"
              @click:wishlist="toggleWishlist(product)" @click:add-to-cart="cartClick(product)">
              <template #image>
                <div class="catImg" @mouseleave="handlerMouseleaveProduct(product)"
                  @mouseover="handlerMouseoverProduct(product)">
                  <nuxt-link :to="localePath(
                    `/p/${productGetters.getId(product)}/${productGetters.getSlug(
                      product
                    )}`
                  )">
                    <template
                      v-if="MouseoverProduct && MouseoverProduct.goodId == product.goodId && MouseoverProduct.images.length > 1">
                      <SfHero class="productHero productImg"
                        :sliderOptions="{ type: 'slider', rewind: true, autoplay: 1000, perView: 1, gap: 0, hoverpause: false }">
                        <template v-for="(image, i) in MouseoverProduct.images">
                          <SfHeroItem :key="i" :image="image.normal" :nuxtImgConfig="{ modifiers: { format: 'webp' } }">
                          </SfHeroItem>
                        </template>
                        <template #bullets>
                          <div></div>
                        </template>
                        <template #next>
                          <div></div>
                        </template>
                        <template #prev>
                          <div></div>
                        </template>
                      </SfHero>
                    </template>
                    <SfImage v-else class="productImg"
                      :class="{ mouseoverImg: MouseoverProduct && MouseoverProduct.goodId === product.goodId }"
                      :src="product.imageUrl" :alt="product.title" :width="190" :height="190" />
                  </nuxt-link>
                </div>
              </template>
              <!-- <template #reviews>
                <div>
                  <div style="display:flex;flex-wrap: wrap;align-items: flex-end;font-size:10pt"
                    v-if="product.deliveryCountries && product.deliveryCountries.length">
                    <div v-for="Countries in product.deliveryCountries" style="margin-right:5px;margin-bottom:5px;">{{
                      $t(Countries.deliveryCountry) }}</div>
                  </div>
                </div>
              </template> -->
              <template #price>
                <div v-if="product && product.goodId" style="margin: var(--product-card-margin, 0);height:28.8px;align-content: center;">
                  <get-discount :goods="product" />
                </div>
              </template>
            </Sf-productCard>
          </template>
        </div>
      </SfLoader>
      <div style="text-align: center;margin-top:1rem;" v-if="products && products.length == 10">
        <SfButton class="sf-button--text" style="font-size: var(--font-size--lg)" @click="goMore()">{{ $t('more') }}
        </SfButton>
      </div>
    </div>
  </div>
</template>
</template>
<script>
import { SfTabs, SfProductCard, SfHero, SfImage, SfButton, SfCarousel, SfScrollable, SfLoader } from "@storefront-ui/vue";
import {
  computed,
  ref,
  onMounted,
  useRouter
} from "@nuxtjs/composition-api";
import getDiscount from "./getDiscount";
import { onSSR } from '@vue-storefront/core';
import { useCategoryTree, facetGetters, productGetters, useWishlist, useOCart, useGoodsSearch } from '@bee-hole/coms';
export default {
  setup(props, context) {
    const router = useRouter();
    const { addItem: addItemToWishlist, isInWishlist, removeItem: removeItemFromWishlist, wishlist: currentWishlist } = useWishlist();

    const { catTrees } = useCategoryTree("header_cat");
    const { search: searchProduct, goodsResult, loading } = useGoodsSearch('cat-goods');
    // const { result, search: searchList } = useFacet('cat-goods');
    const { addItem: addItemToCart } = useOCart();
    const products = computed(() => {
      // return facetGetters.getProducts(result.value);
      return facetGetters.getProducts({ data: { list: goodsResult.value?.list } });
    });
    const MouseoverProduct = ref();
    const activeCat = ref(1);
    const CatList = computed(() => {
      if (!props.filterCat) {
        let CatList1 = JSON.parse(JSON.stringify(catTrees.value));
        if (CatList1) {
          CatList1.unshift({
            catId: 0,
            name: context.root.$t('See_all'),
            slug: 'all'
          });
        }
        return CatList1;
      }
    });
    const addItemForWishlist = (product) => {
      if (product.product?.skus?.length > 1) {
        router.push(context.root.localePath(`/p/${product.product.goodId}/${product.product?.slug || product.product.title}`));
      } else {
        product.product.skuId = product.product.skus[0].skuId;
        addItemToWishlist(product);
      }
    };
    const removeProductFromWishlist = (productItem) => {
      const product = currentWishlist.value.list.find(wishlistProduct => wishlistProduct.goodId === productItem.goodId);
      removeItemFromWishlist({ product });
    };
    const toggleWishlist = (product) => {
      !isInWishlist({ product }) ? addItemForWishlist({ product }) : removeProductFromWishlist(product);
    };
    const addCartGoogle =(product)=>{
      const sku = product.skus?.[0]
      const googleCartItem ={
        currency: context?.root?.$cookies?.get('vsf-currency'),
        value: sku.price,
        items: [
          {
            item_id: product.goodId,
            item_name: product.title,
            price: sku?.price,
            quantity: 1,
            item_variant: '',
          },
        ],
      }
      context.root.$gtm.push(
      {
        event: "add_to_cart",
        ecommerce: googleCartItem
      });
    }
    const cartClick = async (product) => {
      if (product?.skus?.length === 1) {
        await addItemToCart({ product, quantity: 1 });
        addCartGoogle(product);
      } else {
        router.push(context.root.localePath(`/p/${productGetters.getId(product)}/${productGetters.getSlug(
          product
        )}`));
      }
    };
    const handlerMouseoverProduct = (product) => {
      MouseoverProduct.value = product;
    };
    const handlerMouseleaveProduct = (product) => {
      if (MouseoverProduct.value?.goodId === product.goodId) {
        MouseoverProduct.value = null;
      }
    };
    if (props.filterCat) {
      // CatList.value = props.filterCat;
    }
    const changeCat = async (tab) => {
      activeCat.value = tab;
      const cat = CatList.value?.[activeCat.value - 1];
      // await searchList({ limit: 10, page: 1, catId: cat.catId });
      await searchProduct({ limit: 10, page: 1, cat_id: cat.catId });
    };
    onMounted(async () => {
    });
    onSSR(async () => {
      // await catTreeGet({});
      if (CatList.value?.length > 1) {
        activeCat.value = 1;
        // const cat = CatList.value?.[activeCat.value - 1];
        // await searchList({ limit: 10, page: 1, catId: 0 });
        await searchProduct({ limit: 10, page: 1, cat_id: 0 });
      }
    });
    const goMore = () => {
      router.push(context.root.localePath(`/c/${CatList.value?.[activeCat.value - 1]?.catId}/${CatList.value?.[activeCat.value - 1]?.slug}`));
    };
    return {
      CatList,
      activeCat,
      changeCat,
      products,
      productGetters,
      isInWishlist,
      toggleWishlist,
      cartClick,
      MouseoverProduct,
      handlerMouseoverProduct,
      handlerMouseleaveProduct,
      goMore,
      loading
    };
  },
  components: {
    SfTabs,
    SfProductCard,
    SfHero,
    SfImage,
    SfButton,
    SfCarousel,
    SfScrollable,
    getDiscount,
    SfLoader
  }
};
</script>
<style lang="scss">
#CatProduct {
  position: relative;
  .sf-product-card__image-wrapper {
    text-align: center;
  }

  .sf-product-card {
    @include for-mobile {
      max-width: calc((130px) + (var(--spacer-sm) * 2)) !important;
      width: calc((130px) + (var(--spacer-sm) * 2)) !important;
      padding: 0;
      margin-bottom:0.5rem;
    }

    @include for-desktop {
      max-width: calc((190px) + (var(--spacer-sm) * 2)) !important;
      width: calc((190px) + (var(--spacer-sm) * 2)) !important;
    }
  }
  /* .CatProduct__tabs__content::-webkit-scrollbar {
        display: none;
      } */
  .CatProduct__tabs {
    overflow: hidden;
    .CatProduct__tabs__content {
      display: flex !important;
      flex-direction: row;
      flex-wrap: nowrap;
      overflow-x: auto;
      overflow-y: hidden !important;
      padding-bottom: 10px !important;
      scroll-behavior: smooth;
      .sf-tabs__title {
        word-break: keep-all !important;
        --tabs-title-flex: 1 !important;
        flex: 1 !important;
        white-space: nowrap !important;
        border-bottom: 0px;
      }

      .is-active {
        border-bottom: 1px solid var(--tabs-title-color);
      }

      .sf-tabs__content {
        display: none;
      }
    }
    ::-webkit-scrollbar-track {
        background-color: #d3d3d4; /* 设置滚动条轨道的颜色 */
    }

    ::-webkit-scrollbar-thumb {
        background-color: #7f828e; /* 设置滚动条滑块的颜色 */
    }
    .CatProduct__tabs__content::-webkit-scrollbar{
      display: none;
    }
    .CatProduct__tabs__content:hover::-webkit-scrollbar{
      height:0.5em;
      display: block;
    }
    /* ::-webkit-scrollbar {
        display: none;
      }; */
  }

  .CatItemList1 {
    display: grid;
    justify-items: center;

    @include for-mobile {
      grid-template-columns: repeat(auto-fill, minmax(calc((130px) + (var(--spacer-sm) * 2)), 1fr));
    }

    @include for-desktop {
      grid-template-columns: repeat(auto-fill, minmax(calc((190px) + (var(--spacer-sm) * 2)), 1fr));
    }
  }
}
</style>
